import axios from '../../plugins/axios'

export const buscarModelos = (_, { q, cursor, limit }) => {
  const params = new URLSearchParams()
  params.append('q', q)
  params.append('limit', limit || 20)
  if (cursor) params.append('cursor', cursor)
  return axios
    .get(`api/garantias/modelos/?${params.toString()}`)
    .then((r) => r.data)
}

export const fetchProductosGarantia = () =>
  axios.get('api/garantias/productos/').then((r) => r.data)

export const solicitarCreacionModelo = (_, formData) =>
  axios
    .post('api/garantias/modelos/solicitar-creacion/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)

// Paso 3: extensiones de tiempo disponibles para el segmento del modelo.
// fechaCompraEquipo permite al backend bloquear si la garantía base ya expiró
// y devolver base_warranty_years para mostrarlo en pantalla.
export const fetchExtensiones = (_, { modeloId, fechaCompraEquipo }) => {
  const params = new URLSearchParams()
  params.append('modelo_id', modeloId)
  if (fechaCompraEquipo) params.append('fecha_compra_equipo', fechaCompraEquipo)
  return axios
    .get(`api/garantias/extensiones/?${params.toString()}`)
    .then((r) => r.data)
}

// Paso 4: protecciones disponibles según segmento, años totales (base +
// extensión elegida) y la regla de 180 días desde la compra del equipo.
export const fetchProtecciones = (
  _,
  { modeloId, extensionId, fechaCompraEquipo }
) => {
  const params = new URLSearchParams()
  params.append('modelo_id', modeloId)
  params.append('fecha_compra_equipo', fechaCompraEquipo)
  if (extensionId) params.append('extension_id', extensionId)
  return axios
    .get(`api/garantias/protecciones/?${params.toString()}`)
    .then((r) => r.data)
}

export const solicitarCompra = ({ state }) => {
  const {
    cliente,
    equipo,
    boleta,
    fechaCompraEquipo,
    extension,
    protecciones,
    cupon,
  } = state
  const fd = new FormData()
  fd.append('correo', (cliente && cliente.correo) || '')
  fd.append('nombre', (cliente && cliente.nombre) || '')
  fd.append('apellido', (cliente && cliente.apellido) || '')
  fd.append('rut', (cliente && cliente.rut) || '')
  fd.append('telefono', (cliente && cliente.telefono) || '')
  fd.append('numero_serie', (equipo && equipo.numero_serie) || '')
  fd.append('fecha_compra_equipo', fechaCompraEquipo || '')
  fd.append('modelo_id', (equipo && equipo.modelo_id) || '')
  if (extension) fd.append('extension_id', extension.id)
  ;(protecciones || []).forEach((p) => fd.append('protecciones_ids', p.id))
  if (boleta) fd.append('boleta_cliente', boleta)
  // OVG03.2 — incluir cupón si fue validado (SILL-1523)
  if (cupon && cupon.codigo) fd.append('codigo_cupon', cupon.codigo)
  return axios
    .post('api/garantias/solicitudes/', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)
}

// OVG03.2 — Validar cupón de garantías (SILL-1523)
// POST /api/garantias/cupones/validar/ → { codigo, porcentaje_descuento }
export const validarCuponGarantia = ({ commit }, codigo) => {
  commit('SET_CUPON_LOADING', true)
  commit('SET_CUPON_ERROR', null)
  commit('SET_CUPON', null)
  return axios
    .post('api/garantias/cupones/validar/', {
      codigo: (codigo || '').trim().toUpperCase(),
    })
    .then((r) => {
      commit('SET_CUPON', {
        codigo: r.data.codigo,
        porcentaje_descuento: r.data.porcentaje_descuento,
      })
    })
    .catch((err) => {
      const status = err && err.response && err.response.status
      if (status === 404) {
        commit('SET_CUPON_ERROR', 'El código de descuento no es válido.')
      } else {
        commit(
          'SET_CUPON_ERROR',
          '¡Lo sentimos! El código de descuento ya no está disponible.'
        )
      }
    })
    .finally(() => {
      commit('SET_CUPON_LOADING', false)
    })
}

// OVG03.2 — Limpiar el cupón activo o con error (SILL-1523)
export const limpiarCupon = ({ commit }) => {
  commit('SET_CUPON', null)
  commit('SET_CUPON_ERROR', null)
  commit('SET_CUPON_LOADING', false)
}

// PagoView.vue (pantalla pública de pago) — antes llamaba axios directo
// desde el componente en vez de pasar por el store, como el resto del flujo.
export const fetchDatosPago = (_, token) =>
  axios.get(`api/garantias/pago/${token}/`).then((r) => r.data)

export const validarRutContribuyente = (_, rut) =>
  axios.get(`api/oportunidadventa/contribuyente/${rut}/`).then((r) => r.data)

export const guardarFacturaPago = (
  _,
  { token, rut_contribuyente, razon_social_contribuyente }
) =>
  axios.post(`api/garantias/pago/${token}/factura/`, {
    rut_contribuyente,
    razon_social_contribuyente,
  })

export const iniciarPagoOvg = (_, token) =>
  axios.post(`api/garantias/pago/${token}/iniciar/`).then((r) => r.data)
